const pages = {
  ARRIVAL_PAGE: "arrival",
  COMPLETE_PAGE: "complete",
  DEPARTURE_PAGE: "departure",
  EDUCATION_PAGE: "education",
  PERSONALITY_PROFILE_PAGE: "personality_profile",
  GUARDIAN_EMERGENCY_PAGE: "guardian_emergency",
  LANGUAGE_NATIONALITY_PAGE: "language_nationality",
  MEDICAL_PAGE: "medical",
  PETS_CHILDREN_PAGE: "pets_children",
  PLACEMENT_PAGE: "placement",
  PRODUCT_PAGE: "product",
  REGISTER_PAGE: "register",
  ADDRESS_PAGE: "address",
  FIREBASE_REGISTER_FORM_PAGE: "firebase_register_form",
  FIREBASE_ACCOUNT_DETAILS_FORM_PAGE: "firebase_account_details_form",
  RETURN_LATER_PAGE: "return_later"
}
export default pages
